import { useEffect, useState } from "react";

// Project import
import useAuth from "./useAuth";
import { CustomCategories } from "types/auth";

const useCustomCategories = () => {
  // --- Hooks --- //
  const { speciesSchemes, selectedSpeciesSchemeId } = useAuth();
  // --- States --- //
  const [customCategories, setCustomCategories] = useState<CustomCategories | undefined>(undefined);
  // --- Effects --- //
  useEffect(() => {
    if (speciesSchemes && selectedSpeciesSchemeId) {
      const selectedScheme = speciesSchemes[selectedSpeciesSchemeId];
      if (selectedScheme) {
        setCustomCategories(selectedScheme.customCategories);
      } else {
        setCustomCategories(undefined);
      }
    } else {
      setCustomCategories(undefined);
    }
  }, [speciesSchemes, selectedSpeciesSchemeId]);

  return { customCategories };
};

export default useCustomCategories;
